import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatIdentityDeletedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const identityDeleted: CaseReducer<NinchatState> = (state, action) => {
    const {
        identity_name,
        identity_type,
        user_id,
        ...rest
    } = extractProperties<NinchatIdentityDeletedEvent>(action.payload)

    isEmpty(rest)

    if (user_id === state.user_id) {
        const ref = state.user_identities[identity_type] ?? {}

        delete ref[identity_name]
    }
}
